export default {
    index: 'Index',
    marker: 'Highlighting',
    dictionary: 'Dictionary',
    question: 'Question',
    storyletter: 'Read aloud',
    settings: 'Settings',
    notes: 'My notes',
    music: 'Music',
    searchInput: 'Search Definition...',
    warnDictionary: 'You must search one word at a time.',
    warnMark: 'To mark a text, you need to select a phrase with at least five words.',
    not_question: 'There are no questions in this chapter.',
    finish_book: 'You have reached the end of the book',
    congrats: 'Congratulations!',
    finish_book_msg: 'Rate it and then press the button to return to the beginning and continue',
    go_back: 'Go to star',
    bad: 'Bad',
    regular: 'Regular',
    good: 'Good!',
    very_good: 'Very good!',
    excellent: 'Excellent!',
    magnificent: 'Magnificent',
    start_reading: 'Start reading',
    qualification: 'Cualification',
    days_to_finish: 'Days for finish',
    go_to_library: 'Go to the library',
    go_to_home: 'Rate and go to home',
    congrats_msg_1: 'You have finished reading',
    finish_msg_1: 'Tell us, did you like the book?',
    finish_msg_2: 'How did you like this book?',
    send: 'send',
    chapter: 'Capítulo',
    answer: 'Answer',
    try_again: 'Try again',
    continue: 'Continue',
    understood: 'Understood',
    clue: 'Clue',
    buy_wildcard: 'Buy wildcard',
    have: 'You have',
    wildcard_50_50: '50/50 <br> Wildcard',
    wildcard_buy_msg:
        'Eliminate 50% of the alternatives and increase your probability of hitting.',
    wildcard_used_msg: 'You bought the 50/50 Wildcard',
    characters: 'Characters',
    actions: 'Actions',
    vocabulary: 'Vocabulary',
    places: 'Places',
    highlight_modal_msg: 'Select the category in which you want to save your bookmark:',
    warnMarkSelectType: 'You must select a marker type to continue',
    highlight_saved: 'Highlight Saved',
    located_in: 'Located in',
    page: 'page',
    of: 'of',
    music_2: 'Background music',
    music_msg_1: 'You can activate and desactivate the background music if you wish.',
    listen_background_music: 'Listen background music',
    activate: 'Activate',
    desactivate: 'Desactivate',
    without_highlights: 'Without highlights for to show',
    comments: 'Comentarios',
    dictionary_msg_1: 'Enter the word you want to search for',
    dictionary_placeholder: 'Example: empathy',
    search_word: 'Search word',
    example: 'Example',
    notes_modal_msg: 'Write the note you want to create',
    notes_modal_placeholder: 'Type your note here...',
    without_notes: 'Without notes for to show',
    showAllNotes: 'show my notes in the text always.',
    reading_aloud: 'Narration',
    listen_read_aloud: 'Hear narration voice',
    readaloud_msg_1: 'You can turn narration audio on and off if you wish.',
    not_storyteller_data_found:
        'The narrator is not available for this reading, you can try again later.',
    choose_voice: 'Choose the voice you prefer',
    my_notes: 'My notes',
    note_pill_msg: 'Note created',
    inactivity_modal: 'Are you still reading? We have detected that you have not changed pages for 30 minutes.',
    reread_modal_msg: 'You have already read this book completely. Do you want to start again?',
    without_beecoins: `Oops! You do not have enough BeeCoins to use the 50/50 wildcard. Correctly answer questions from books and challenges to earn rewards.`,
    wildcard_alredy_use: 'You have already used a wildcard for this question',
    multiple_selection_only: 'This option is only available for multiple choice questions',
    no_meaning: 'We find no meaning.',
    not_available: 'The dictionary is not available at the moment, you can try again later.',
    published: 'Published',
    finish_book_msg_1: 'You have finished reading!',
    finish_book_msg_2: 'It is time to choose your next challenge from the library.',
    saved_the: 'Saved the',
    the_word: 'The word',
    congrats_questions: 'You have answered all available questions.',
    go_out: 'Go out',
    pause_read_aloud: 'Pause narration <br> to make changes',
    no_audio_available: 'Audio not available for this book',

}
